import React, { useEffect, useRef, memo } from 'react';
import classNames from 'classnames';

import uniqueId from '../../../utils/uniqueId';
import { isChanged, unwrap } from '../../../utils/ChangeSpy';
import FieldError from '../../helpers/FieldError';

const PhoneInputComponent = ({ contact, onChange, className, onBlur, autoFocus, error, onErrorClose }) => {
  const id = useRef(uniqueId());

  useEffect(() => {
    if (autoFocus) {
      const timeout = setTimeout(() => {
        try {
          document.getElementById(id.current).focus();
        } catch (focusError) {
          console.warn(focusError);
        }
      }, 0);

      return () => clearTimeout(timeout);
    }
  }, [autoFocus]);

  const handleFocus = () => {
    if (onErrorClose) {
      onErrorClose();
    }
  };

  const divClass = classNames('clearfix form-group', className, { 'has-error': error });
  const value = unwrap(contact.get('unformattedPhone'));
  const changed = isChanged(contact.get('unformattedPhone'));
  const inputClass = classNames('form-control input-md', { changed });

  return (
    <div className={divClass}>
      <label htmlFor={id.current}>Phone</label>
      <span className="control-wrap">
        <input
          className={inputClass}
          id={id.current}
          maxLength={30}
          name="unformattedPhone"
          onBlur={onBlur}
          onChange={onChange}
          onFocus={handleFocus}
          value={value}
        />
      </span>
      <FieldError message={error} />
    </div>
  );
};

export const PhoneInput = memo(PhoneInputComponent);
